import type { Org } from "@crucible/types";

export interface TenantContext {
  orgSlug: string | null;
  host: string;
  isAppHost: boolean;
}

const APP_HOST_PREFIX = "app.";
const ORG_SUBDOMAIN_SUFFIX = ".app.";

/** Resolve tenant org slug from hostname (e.g. horizon.app.hicrucible.com → horizon). */
export function resolveTenantFromHost(host: string): TenantContext {
  const normalized = host.split(":")[0].toLowerCase();

  if (normalized.startsWith(APP_HOST_PREFIX)) {
    return { orgSlug: null, host: normalized, isAppHost: true };
  }

  const appIndex = normalized.indexOf(ORG_SUBDOMAIN_SUFFIX);
  if (appIndex > 0) {
    return {
      orgSlug: normalized.slice(0, appIndex),
      host: normalized,
      isAppHost: true,
    };
  }

  return { orgSlug: null, host: normalized, isAppHost: false };
}

export function tenantOrgHeader(org: Org | null): Record<string, string> {
  return org ? { "X-Org-Slug": org.slug } : {};
}